import React from 'react'
import { repeat } from 'lodash'

import { IconChecked, IconUnchecked } from '../../svg/index'

import './ColumnOptions.scss'

const ColumnOptions = ({ className = '', options, shortened = false, lang = 'en-US' }) => (
    <>
        {options.map(({ enabled, name, hasOption, productOptionValue, under }, i) => {
            if (!enabled) {
                return (
                    <BoolOption
                        className={className}
                        key={i}
                        value={false}
                        name={name}
                        under={under}
                        shortened={shortened}
                    />
                )
            }

            if (!hasOption) {
                return (
                    <BoolOption
                        className={className}
                        key={i}
                        value={true}
                        name={name}
                        under={under}
                        shortened={shortened}
                    />
                )
            }

            if (typeof productOptionValue === 'number') {
                return productOptionValue === 0 ? (
                    <BoolOption
                        className={className}
                        key={i}
                        value={false}
                        name={name}
                        under={under}
                        shortened={shortened}
                    />
                ) : (
                    <NumberOption
                        className={className}
                        key={i}
                        value={productOptionValue}
                        name={name}
                        under={under}
                        shortened={shortened}
                        lang={lang}
                    />
                )
            }

            throw Error('uncovered case')
        })}
    </>
)

const getCustomName = (name, children) => {
    if (name === 'Ads free') return 'Ad-free'
    if (name === 'Websites' && children === '1') return 'Website'
    return name
}

const getOptionValueClass = (shortened, children) => {
    let className = 'column-option__option-value'
    if (shortened && children === 'custom') className += ' column-option__option-value__small_font'
    return className
}

const Option = ({ className, children, name, under, shortened }) => (
    <div className={`column-option__option ${className}`}>
        <div className={getOptionValueClass(shortened, children)}>{children}</div>
        {shortened ? (
            <div className="column-option__description-box">
                <span>{getCustomName(name, children)}</span>
                {under !== void 0 ? <span className="column-option__description">{under}</span> : null}
            </div>
        ) : null}
    </div>
)

const BoolOption = ({ className, value, name, under, shortened }) => (
    <Option className={className} name={name} under={under} shortened={shortened}>
        {value ? <IconChecked /> : <IconUnchecked />}
    </Option>
)

const shorten = (value, lang) => {
    if (value.toString().length >= 4) {
        const thousandAmount = Math.trunc((value.toString().length - 1) / 3)

        const result = value / 10 ** (thousandAmount * 3)

        return `${result}${repeat('K', thousandAmount)}`
    }

    return value.toLocaleString(lang)
}

const NumberOption = ({ className, value, name, under, shortened, lang }) => {
    let displayValue
    if (value === -1) {
        displayValue = 'custom'
    } else if (shortened) {
        displayValue = shorten(value, lang)
    } else {
        displayValue = value.toLocaleString(lang)
    }

    return (
        <Option className={className} name={name} under={under} shortened={shortened}>
            {displayValue}
        </Option>
    )
}

export default ColumnOptions
